import * as React from 'react';
import {Component} from 'react';
import Scrollbars from 'react-custom-scrollbars';
import {tabs} from '../consts';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {getMenuProps} from '../utils/FooterUtils';
import EntityIcon from '../../../components/Common/EntityIcon/EntityIcon';
import {keyCodes} from '../../../constants';
import {togglePinActiveScreens} from '../../../_shared/GWTBridge/invoke/footerPanel';
import {EntityType} from '../../../constants/EntityTypes';
import {sendMonitor} from '../../../utils/monitoring';

interface TabItem {
    title: string;
    type?: EntityType;
    isCurrent?: boolean;
    menuButton?: any;
    action: (event, menuButton, screenId?) => void;
    pageItem?: any;
    screenId?: string;
    closeAction?: (item) => void;
}

interface ScrollState {
    selectedIndex: number;
}

class FooterTabMenu extends Component<any, ScrollState> {
    scrollbar;
    wrapperRef;
    constructor(props) {
        super(props);

        this.state = {
            selectedIndex: -1
        };

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.tabIndex === tabs.ACTIVE_SCREENS) {
            nextProps.activeScreens.forEach((item, index) => {
                if (item.isCurrent && item.isCurrent(item.menuButton)) {
                    if (this.state.selectedIndex !== index) {
                        this.setState({selectedIndex: index}, () => {
                            this[`item_${index}`].focus();
                        });
                    }
                    return;
                }
            });
        } else if (this.state.selectedIndex !== -1) {
            this.setState({selectedIndex: -1});
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown, true);
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true);
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    closeActiveScreens() {
        const {funcs} = this.props;
        if (funcs) {
            funcs.closeOpnedScreens();
        }
    }

    handleKeyDown(e) {
        if (this.props.tabIndex === null) {
            return;
        }

        if (e.keyCode === keyCodes.ESC) {
            e.stopPropagation();
            this.props.closeMenu();
        } else if (e.keyCode === keyCodes.ENTER) {
            e.stopPropagation();

            const {dataItems} = getMenuProps(this.props);
            const {selectedIndex} = this.state;
            const item = dataItems[selectedIndex];

            item.action(e, item.menuButton, item.screenId);
        } else {
            const ArrowKeys = [keyCodes.ARROW_DOWN, keyCodes.ARROW_UP];
            if (ArrowKeys.includes(e.keyCode)) {
                this.handleArrowKeys(e);
            }
        }
    }

    handleArrowKeys(e) {
        const {selectedIndex} = this.state;
        const {dataItems} = getMenuProps(this.props);
        let newSelectedIndex = -1;
        e.stopPropagation();

        if (e.keyCode === keyCodes.ARROW_DOWN) {
            const itemsLength = dataItems.length - 1;
            newSelectedIndex = selectedIndex === itemsLength ? itemsLength : selectedIndex + 1;
        } else if (e.keyCode === keyCodes.ARROW_UP) {
            newSelectedIndex = selectedIndex === 0 ? 0 : selectedIndex - 1;
        }

        this[`item_${newSelectedIndex}`].focus();
        this.setState({selectedIndex: newSelectedIndex});
    }

    handleClickOutside(e) {
        if (
            this.wrapperRef &&
            !this.wrapperRef.contains(e.target) &&
            !this.props.footerRef.contains(e.target)
        ) {
            e.stopPropagation();
            this.props.closeMenu();
        }
    }

    renderItems(dataItems: Array<TabItem>, tabIndex: number) {
        return dataItems.map((item, index) => {
            return (
                <div
                    key={index}
                    tabIndex={index}
                    ref={item => {
                        this['item_' + index] = item;
                    }}
                    className={`content ${index === this.state.selectedIndex ? 'selected' : ''}`}
                    onClick={e => {
                        const monitorText =
                            tabIndex === tabs.RECENT_ITEMS
                                ? 'Form_RecentItems'
                                : tabIndex === tabs.LAST_UPDATES
                                ? 'Form_LatesUpdates'
                                : tabIndex === tabs.ACTIVE_SCREENS
                                ? 'Form_ActiveScreens_Click'
                                : null;
                        monitorText && sendMonitor(monitorText);
                        item.action(e, item.menuButton, item.screenId);
                    }}
                >
                    {this.renderItemImage(item, tabIndex)}
                    <div className="title">{item.title}</div>
                    {this.props.tabIndex === tabs.ACTIVE_SCREENS && (
                        <div
                            className="close-screen"
                            onClick={e => {
                                e.stopPropagation();
                                item.closeAction(item.menuButton);
                                this.props.closeMenu();
                            }}
                        >
                            <Icon icon={PriorityIcon.x} componentClasses="svg-close-image" />
                        </div>
                    )}
                </div>
            );
        });
    }

    renderItemImage(item: TabItem, tabIndex: number) {
        if (tabIndex === tabs.LAST_UPDATES) {
            return null;
        }

        return <EntityIcon type={item.type} />;
    }

    renderCloseAll(tabIndex: number) {
        if (tabIndex === tabs.ACTIVE_SCREENS) {
            return (
                <span
                    className="close-all"
                    onClick={() => {
                        this.closeActiveScreens();
                    }}
                >
                    {getLocalizedText(texts.closeAll)}
                </span>
            );
        }

        return null;
    }

    render() {
        const {closeMenu, tabIndex} = this.props;
        const isPinned = localStorage.getItem('isActiveScreensPinned');

        if (tabIndex === null) {
            return null;
        }

        const {tabType, dataItems, menuTitle} = getMenuProps(this.props);

        return (
            <div ref={this.setWrapperRef} className={`tab-menu ${tabType}`}>
                <header>
                    <div className="header-title">
                        <span>{menuTitle}</span>
                        {this.renderCloseAll(tabIndex)}
                    </div>
                    <div className="close-section">
                        {this.props.tabIndex === tabs.ACTIVE_SCREENS && (
                            <div
                                className="active-screens-header-pin"
                                onClick={() => {
                                    sendMonitor('Form_ActiveScreens_Pinned');
                                    togglePinActiveScreens(true);
                                }}
                            >
                                <Icon
                                    iconColor="secondary-500"
                                    icon={isPinned ? PriorityIcon.pinPinned : PriorityIcon.pin}
                                />
                            </div>
                        )}
                        <Icon
                            icon={PriorityIcon.x}
                            onClick={closeMenu}
                            darkContainer
                            skin="standart"
                            componentClasses="footer-tab-close-icon"
                        />
                    </div>
                </header>
                <section>
                    <Scrollbars
                        ref={s => (this.scrollbar = s)}
                        className={`scroll-area`}
                        renderThumbVertical={props => (
                            <div {...props} className="footer-items-scroller" />
                        )}
                        autoHeight
                        autoHeightMax={380}
                    >
                        {this.renderItems(dataItems, tabIndex)}
                    </Scrollbars>
                </section>
            </div>
        );
    }
}

export default FooterTabMenu;
